import { useContext } from 'react';

import PopupsContext from '@app/contexts/PopupsContext';

export const usePopupsContext = () => {
  return useContext(PopupsContext);
};
